import styles from "./css/About.module.css";

import YY from "../Img/yarin.png";
import YK from "../Img/kalaidzidis.png";
import ML from "../Img/lippmann.png";
import SK from "../Img/alex_kalaizidis.png";
import { useContext } from "react";
import AuthContext from "../store/auth-context";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import Main from "../components/UI/Main/Main";
import PdfModalLink from "../components/PdfModalLink/PdfModalLink";
import DoctorCvSection from "../components/DoctorCvSection/DoctorCvSection";

const About = () => {
    const ctx = useContext(AuthContext);
    const data = ctx.text.aboutUs

    return (
        <div id="page-wrap" >
            <Header />
            <Main>
                <div className={styles.aboutContainer}>
                    <div className={styles.aboutHeader}>
                        <span className={styles.aboutTitle}>{data.about_subtitle}</span>
                        <hr className={styles.hr} />
                        <h2 className={styles.aboutSubtitle}>{data.about_title}</h2>
                    </div>
                    {/* Person 1 */}
                    <div className={styles.teamMembers}>
                        <div className={styles.teamMember}>
                            <img src={YY} alt="Dr. Yury Yarin" />
                        </div>
                        <div className={styles.teamMember}>
                            <h3>Dr. Yury Yarin</h3>
                        </div>
                        <div className={styles.teamMember}>
                            <p>{data.about_yy}</p>
                            <PdfModalLink content={<DoctorCvSection />} title="CV">
                               {data.viewCv}
                            </PdfModalLink>
                        </div>
                    </div>
                    {/* Person 2 */}
                    <div className={styles.teamMembers}>
                        <div className={styles.teamMember}>
                            <img src={YK} alt="Dr. Yannis Kalaidzidis" />
                        </div>
                        <div className={styles.teamMember}>
                            <h3>Dr. Yannis Kalaidzidis</h3>
                        </div>
                        <div className={styles.teamMember}>
                            <p>{data.about_yk}</p>
                        </div>
                    </div>

                    {/* Person 3 */}
                    <div className={styles.teamMembers}>
                        <div className={styles.teamMember}>
                            <img src={ML} alt="Mike Lippmann" />
                        </div>
                        <div className={styles.teamMember}>
                            <h3>Mike Lippmann</h3>
                        </div>
                        <div className={styles.teamMember}>
                            <p>{data.about_ml}</p>
                        </div>
                    </div>
                    {/* Person 4 */}
                    <div className={styles.teamMembers}>
                        <div className={styles.teamMember}>
                            <img src={SK} alt="Alexander Kalaitzidis" />
                        </div>
                        <div className={styles.teamMember}>
                            <h3>Alexander Kalaitzidis</h3>
                        </div>
                        <div className={styles.teamMember}>
                            <p>{data.about_developer}</p>
                        </div>
                    </div>
                </div>
            </Main>
            <Footer />
        </div>
    );
};

export default About;